/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ConflictViewer.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import CustomButtonV2 from "../../../../components/customComponentsV2/common/button/CustomButtonV2";

export default function ConflictViewer({ conflicts = [], onConfirm, onCancel }) {
  const hasBlocking = conflicts?.some((c) => c.blocking === true);

  return (
    <Box sx={{ mt: 2 }}>
      <Typography color="warning.main" fontWeight={600}>
        Conflicts detected
      </Typography>

      {conflicts?.map((c, idx) => (
        <Box
          key={c.id || c.user_label || `conflict-${c.type}-${idx}`}
          sx={{
            border: "1px solid #f5c26b",
            borderRadius: 1,
            p: 1.2,
            mt: 1,
            background: "#fffaf0",
          }}
        >
          {c.user_label && (
            <Typography fontSize={13} fontWeight={600}>
              👤 {c.user_label}
            </Typography>
          )}

          <Typography fontSize={13}>
            <strong>Type:</strong> {c.type}
          </Typography>

          <Typography fontSize={13}>
            <strong>Reason:</strong> {c.reason}
          </Typography>

          {c.details && (
            <Typography fontSize={12} color="text.secondary">
              {c.details}
            </Typography>
          )}

          {c.blocking && (
            <Typography fontSize={12} color="error">
              This conflict cannot be overridden
            </Typography>
          )}
        </Box>
      ))}

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 1 }}>
        <CustomButtonV2 btnName="Cancel" onClick={onCancel} />

        {!hasBlocking && (
          <CustomButtonV2 btnName="Proceed Anyway" handleOnClick={onConfirm} />
        )}
      </Box>
    </Box>
  );
}

ConflictViewer.propTypes = {
  conflicts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      user_label: PropTypes.string,
      type: PropTypes.string,
      reason: PropTypes.string,
      details: PropTypes.string,
      blocking: PropTypes.bool,
    })
  ),
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};



